import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const CenterLoader = styled.div `
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50vh;
`;
const LdsDualRing = styled.div `
  display: inline-block;
  width: 80px;
  height: 80px;
  &::after {
    content: ' ';
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #1976d2;
    border-color: #1976d2 transparent #1976d2 transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
export const Loader = () => (_jsx(CenterLoader, { children: _jsx(LdsDualRing, {}) }));
